import { Button } from '@eppendorf/vnls-react-components';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

export enum ReportStatusFilter {
  All = 'all',
  Ready = 'Ready',
  Processing = 'Processing',
  Pending = 'Pending',
  Error = 'Error',
}

export const REPORT_STATUS_FILTERS = Object.values(ReportStatusFilter);

interface ReportStatusFilterProps {
  selectedStatus: ReportStatusFilter;
  onStatusChange: (status: ReportStatusFilter) => void;
  className?: string;
}

export function ReportStatusFilterComponent({
  selectedStatus,
  onStatusChange,
  className,
}: ReportStatusFilterProps) {
  const { t } = useTranslation();

  const statusLabels = new Map<ReportStatusFilter, string>([
    [ReportStatusFilter.All, t('reportHub.filters.all')],
    [ReportStatusFilter.Ready, t('reportHub.filters.ready')],
    [ReportStatusFilter.Processing, t('reportHub.filters.processing')],
    [ReportStatusFilter.Pending, t('reportHub.filters.pending')],
    [ReportStatusFilter.Error, t('reportHub.filters.error')],
  ]);

  return (
    <div className={cn('flex gap-s', className)}>
      {REPORT_STATUS_FILTERS.map((status) => {
        const isSelected = selectedStatus === status;
        return (
          <Button
            key={status}
            variant={isSelected ? 'primary' : 'outline'}
            onClick={() => onStatusChange(status)}
            size="pill"
            className={!isSelected ? 'bg-white' : ''}
          >
            <span className="font-size-s">{statusLabels.get(status)}</span>
          </Button>
        );
      })}
    </div>
  );
}
